import { Config, App } from "./app"

export function initialize(config: Config): App {
	const app = new App(config);
	app.startSession();
	return app;
}